export const amountToCopCurrency = (amount) => {
  const copFormatter = new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  });
  return copFormatter.format(amount);
};
